import { Schema as S } from "effect";
import { stringFromPrefixedString, stringFromOptionallyPrefixedString } from "../utils";
export const RawSchema = S.UUID;
export const Schema = stringFromPrefixedString("$SuperwallDevice:", RawSchema).pipe(S.brand("@open-revenue/schema/DeviceId"));
export const FromOptionallyPrefixedString = stringFromOptionallyPrefixedString("$SuperwallDevice:", RawSchema).pipe(S.brand("@open-revenue/schema/DeviceId"));
export const FromUnPrefixedString = RawSchema.pipe(S.brand("@open-revenue/schema/DeviceId"));
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
export const random = ()=>S.decodeUnknown(Schema)(`$SuperwallDevice:${crypto.randomUUID()}`);
